






































import { defineComponent, reactive, ref, useContext, watch } from '@nuxtjs/composition-api'
import { SfCheckbox, SfRadio } from '@storefront-ui/vue';
import { merge } from 'lodash-es';
import useProductPage from '~/composables/useProductPage';
import { DURATION_LABEL_KEYS } from '~/utils/constants/layout';
import { BUNDLE_TYPE_ID } from '~/utils/constants/product';

export default defineComponent({
    components:{
        SfCheckbox,
        SfRadio
    },
    setup() {
        const {product, addToCartConfigs, setAddToCartConfigs, paymentFrequencyChoosen, setPaymentFrequencyChoosen, productLowPaymentFrequency, productHighPaymentFrequency, paperAdded, setPaperAdded, setBundleTipoConsegna} = useProductPage()
        const {app: {i18n}, $fc} = useContext();
        const shippingUid = reactive({})
        const disclaimer = ref<string>('');
        const totalDeliveryPrice = ref<number>(0);
        const getDeliveryCostLabel = (deliveryOption) => {
            const key = DURATION_LABEL_KEYS[paymentFrequencyChoosen.value];
            const duration = i18n.tc(key,1);
            return i18n.tc('+ {price} / each {durationQty} {duration}',1,{
                price : $fc(deliveryOption.cost),
                durationQty: 1,
                duration
            })
        }

        const isDoublePaper = () => {
            return Object.keys(product.value.deliveryCosts).length >= 2;
        }

        /** If the user changes the payment frequency to low, we must deselect the checkbox 
         * and remove the shipping configuration from the cart configs */
        watch(paymentFrequencyChoosen, ()=>{
            if(paymentFrequencyChoosen.value == productLowPaymentFrequency.value){
                Object.keys(paperAdded.value).forEach(key => paperAdded.value[key] = false); //Reset paper checkbox
                let newCartConfig = Object.assign({}, addToCartConfigs.value);
                delete newCartConfig['shippingCost'];
                delete newCartConfig['shippingType'];
                delete newCartConfig[product.value.deliveryAttributeUid];
                setAddToCartConfigs(merge({}, newCartConfig));
            }else {
                Object.keys(deliveryIsRequired).forEach(sku => {
                    setPaperAdded({sku, active: true});
                    const firstElement = Object.keys(product.value.deliveryCosts[sku]);
                    const deliveryCost = product.value.deliveryCosts[sku][firstElement[0]];
                    shippingCostChanged(`${sku}-${deliveryCost.value_index}`);
                    shippingUid[sku] = `${sku}-${deliveryCost.value_index}`;
                    setDisclaimerFunc(deliveryCost.label);
                });
            }
        })
        const choosenShippingMetodLabel = ref<string>();

        const shippingCostChanged = (newVal)=>{
            if(!newVal) return;
            const [sku, valueIndex] = newVal.split('-');
            const deliveryOptions = {};
            let deliveryLabel = "";
            Object.keys(product.value.deliveryCosts).forEach(newSku => {
                if(sku === newSku || shippingUid.hasOwnProperty(newSku)){
                    deliveryOptions[newSku] = product.value.deliveryCosts[newSku][valueIndex];
                    deliveryLabel = product.value.deliveryCosts[newSku][valueIndex].label;
                }
            });
            // if(product.value.productTypeId == BUNDLE_TYPE_ID){
                setBundleTipoConsegna(deliveryLabel);
            // }
            let newConfig = Object.assign({}, addToCartConfigs.value);
            totalDeliveryPrice.value = (Object.values(deliveryOptions).reduce((total, option) => {
                return (total as number) + (option as { cost: number }).cost;
            }, 0) as number);         
            newConfig['shippingCost'] = totalDeliveryPrice;
            newConfig['shippingType'] = deliveryLabel;
            if(!newConfig[product.value.deliveryAttributeUid]){
                newConfig[product.value.deliveryAttributeUid] = {};
            }
            newConfig[product.value.deliveryAttributeUid][sku] = newVal;
            setAddToCartConfigs(merge({},newConfig));

            Object.keys(shippingUid).forEach(sku => {
                shippingUid[sku] = `${sku}-${valueIndex}`
            });
        }

        const setDisclaimerFunc = (label: string) => {
            switch(label.toLowerCase()) {
                case 'posta':
                    disclaimer.value = i18n.t('product_page_shipping_disclaimer') as string;
                    break;
                case 'edicola':
                    disclaimer.value = i18n.t('product_page_shipping_disclaimer_edicola') as string;
                    break;
                default:
                    disclaimer.value = '';
            }
        };

        const handlePaperAddedChange = (newVal: boolean, sku: string) => {
            /** 
             * If the user chooses to add the paper version, the payment frequency must be high 
             */
            if(newVal && paymentFrequencyChoosen.value === productLowPaymentFrequency.value){
                setPaymentFrequencyChoosen(productHighPaymentFrequency.value);
            }
            if(newVal && Object.values(shippingUid).length > 0 && !shippingUid.hasOwnProperty(sku)){
                const firstElement = Object.keys(shippingUid);
                const valueIndex = shippingUid[firstElement[0]].split("-")[1];
                const shipping = `${sku}-${valueIndex}`
                setPaperAdded({sku: sku, active: true});
                shippingCostChanged(shipping);
                shippingUid[sku] = shipping;
            }

            // If the checkbox is unchecked, remove the paper option from the cart configuration
            if(!newVal) {
                let newCartConfig = { ...addToCartConfigs.value };
                if(shippingUid.hasOwnProperty(sku)){
                    const valueIndex = shippingUid[sku].split("-")[1];
                    totalDeliveryPrice.value -= product.value.deliveryCosts[sku][valueIndex].cost;
                    delete shippingUid[sku];
                }
                if (totalDeliveryPrice.value === 0) {
                    delete newCartConfig[product.value.deliveryAttributeUid];
                } 
                if (totalDeliveryPrice.value === 0) {
                    delete newCartConfig['shippingCost'];
                } else {
                    newCartConfig['shippingCost'] = totalDeliveryPrice.value;
                }
                if (totalDeliveryPrice.value === 0) {
                    delete newCartConfig['shippingType'];
                }
                setAddToCartConfigs(merge({}, newCartConfig));
                delete paperAdded.value[sku];
                if (totalDeliveryPrice.value === 0) setDisclaimerFunc('');
                if(product.value.productTypeId === BUNDLE_TYPE_ID && totalDeliveryPrice.value === 0){
                    setBundleTipoConsegna(null);
                }
            }
        };

        watch(
            () => paperAdded.value,
            (newVal) => {
                for (const sku in newVal) {
                    if (newVal.hasOwnProperty(sku) && (Array.isArray(newVal[sku]) || typeof(newVal[sku]) === "boolean")) {
                        handlePaperAddedChange((Array.isArray(newVal[sku]) && newVal[sku].length > 0) || (!Array.isArray(newVal[sku]) && newVal[sku]),sku);
                    }
                }
            },
            { deep: true }
        );

        /**
         * When showAddPaperCheckbox is false it means there are not paper options OR they are present and REQUIRED. 
         * So if the checkbox must not be shown but there are delivery costs it means the paper version is required. 
         */
        const deliveryIsRequired = reactive({});
        product.value.requiredModules.forEach(el => {
            if(el.product.configurable_options.find(el2 => el2.attribute_code === "tipo_consegna")){
                deliveryIsRequired[el.product.sku] = true;
                setPaperAdded({sku: el.product.sku, active: true});
                const firstElement = Object.keys(product.value.deliveryCosts[el.product.sku]);
                const deliveryCost = product.value.deliveryCosts[el.product.sku][firstElement[0]];
                shippingCostChanged(`${el.product.sku}-${deliveryCost.value_index}`);
                shippingUid[el.product.sku] = `${el.product.sku}-${deliveryCost.value_index}`;
                setDisclaimerFunc(deliveryCost.label);
            }
        })
        if(product.value.typeId === "configurable" && product.value.hasPaperToAdd && product.value.hide_paper){
            deliveryIsRequired[product.value.sku] = true;
            setPaperAdded({sku: product.value.sku, active: true});
            const firstElement = Object.keys(product.value.deliveryCosts[product.value.sku]);
            const deliveryCost = product.value.deliveryCosts[product.value.sku][firstElement[0]];
            shippingCostChanged(`${product.value.sku}-${deliveryCost.value_index}`);
            shippingUid[product.value.sku] = `${product.value.sku}-${deliveryCost.value_index}`;
            setDisclaimerFunc(deliveryCost.label);
        }


        return {
            product,
            addToCartConfigs,
            setAddToCartConfigs,
            getDeliveryCostLabel,
            paymentFrequencyChoosen,
            setPaymentFrequencyChoosen,
            productLowPaymentFrequency,
            productHighPaymentFrequency,
            paperAdded,
            choosenShippingMetodLabel,
            i18n,
            disclaimer,
            deliveryIsRequired,
            setPaperAdded,
            setBundleTipoConsegna,
            shippingUid,
            shippingCostChanged,
            isDoublePaper
        }
    },
    methods:{
        setDisclaimer(label){
            switch(label.toLowerCase()){
                case 'posta' : this.disclaimer = this.i18n.t('product_page_shipping_disclaimer') as string; break;
                case 'edicola' : this.disclaimer = this.i18n.t('product_page_shipping_disclaimer_edicola') as string; break;
                default : this.disclaimer = ''
            }
        }
      
    },
})
